/**
 * Load Google Ads
 */

require("./functions")
require("./event_listeners")
